import { useCallback } from 'react';
import type { HueSaturationValue } from '../../lib/adjustments/hue-saturation';
import { RangeRow } from './RangeRow';
import type { AdjustmentPanelProps } from './registry';

export function HueSaturationPanel({ value, onChange }: AdjustmentPanelProps<HueSaturationValue>) {
  const set = useCallback(
    (patch: Partial<HueSaturationValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );

  return (
    <div className="space-y-3">
      <RangeRow
        label="Hue"
        min={-180}
        max={180}
        step={1}
        value={value.hue}
        onChange={(v) => set({ hue: v })}
      />
      <RangeRow
        label="Saturation"
        min={-100}
        max={100}
        step={1}
        value={value.saturation}
        onChange={(v) => set({ saturation: v })}
      />
      <RangeRow
        label="Lightness"
        min={-100}
        max={100}
        step={1}
        value={value.lightness}
        onChange={(v) => set({ lightness: v })}
      />
    </div>
  );
}
